import React from 'react';

import { BaseForm } from 'app-base-form';

import { renderFieldsLayout } from './renderFieldsLayout';

export const BaseFormLayoutContainer = (props) => {
  return <BaseForm {...props} renderFields={renderFieldsLayout} />;
};
